export default "__VITE_ASSET__CZC5PNAo__"